import ProductCard from "./product-card";

export default ProductCard